module.exports = __webpack_public_path__ + "static/img/go-pro-player-mobile.75ed334.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/go-pro-funnel/go-pro-player-mobile.png
// module id = kW7T
// module chunks = 35